import React, { useEffect, useState } from 'react';
import { KTSVG } from '../../../../../_metronic/helpers';
import { ListadoTabla } from './ListadoTabla';
import { useObtenerCuentasPorEtapa } from '../hooks/CuentasCobrarHook';
import { HomeFilterBoard } from '../../../oportunidades/models/OportunidadModel';
import { ListadoTarjeta } from './ListadoTarjeta';
import { FiltroOrdenCobro } from './FilterBoard';

const View: React.FC = () => {
  const [secction, setSecction] = useState<string | 'BOARD' | 'LIST'>('LIST');
  const toggleMode = (mode: 'LIST' | 'BOARD') => {
    localStorage.setItem('viewMode', mode);
    setSecction(mode);
  };

  const [actualizarCuentas, setActualizarCuentas] = useState<number>(
    Math.random() * 40
  );
  const [initFilterValues, setInitFilterValues] = useState<HomeFilterBoard>({
    campo_id: null,
    valor: null,
  });
  const { cuentas, cuentasPorEtapa, cargandoCuentas } =
    useObtenerCuentasPorEtapa(actualizarCuentas, initFilterValues);

  const onCleanFilter = () => {
    setInitFilterValues({
      campo_id: null,
      valor: null,
    });
    setActualizarCuentas(Math.random() * 40);
  };

  const onSearchFilter = (values: any) => {
    if (values) {
      setInitFilterValues(values);
    } else {
      setInitFilterValues({
        campo_id: null,
        valor: null,
      });
    }
    setActualizarCuentas(Math.random() * 40);
  };

  useEffect(() => {
    const storedMode = localStorage.getItem('viewMode');
    if (storedMode) {
      setSecction(storedMode);
    }
  }, []);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12"></div>
      </div>
      <div className="row gy-6 g-xl-9">
        <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
          <div className="card card-flush p-5">
            <div className="row">
              <div className="col-xxl-8 col-xl-8 col-md-8 col-lg-8">
                <ul className="nav nav-line-tabs nav-line-tabs-2x border-transparent fs-7 fw-bolder flex-nowrap">
                  <li className="nav-item cursor-pointer ">
                    <div
                      className={`nav-link me-6 ${
                        secction === 'LIST' ? 'text-active-primary active' : ''
                      } `}
                      onClick={() => {
                        toggleMode('LIST');
                      }}
                    >
                      <KTSVG
                        path="/media/icons/duotune/text/txt001.svg"
                        className="svg-icon-1 fs-7"
                      />
                      <span className="margin-left-05">Lista</span>
                    </div>
                  </li>
                  <li className="nav-item cursor-pointer">
                    <div
                      className={`nav-link me-6  ${
                        secction === 'BOARD' ? 'text-active-primary active' : ''
                      }`}
                      onClick={() => {
                        toggleMode('BOARD');
                      }}
                    >
                      <KTSVG
                        path="/media/icons/duotune/layouts/lay002.svg"
                        className="svg-icon-1 fs-7"
                      />
                      <span className="margin-left-05">Tablero</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-xxl-4 col-xl-4 col-md-4 col-lg-4 position-end">
                <div className="card-title center-items">
                  <div className="mr-05"></div>
                  <FiltroOrdenCobro
                    onCleanFilter={onCleanFilter}
                    onSearchFilter={onSearchFilter}
                    initFilterValues={initFilterValues}
                  ></FiltroOrdenCobro>
                </div>
              </div>
            </div>
            <div className="row">
              {secction === 'LIST' ? (
                <>
                  <ListadoTabla
                    cuentas={cuentas}
                    cargandoCuentas={cargandoCuentas}
                  ></ListadoTabla>
                </>
              ) : (
                <>
                  <ListadoTarjeta
                    etapasConCuentas={cuentasPorEtapa}
                    onRefreshData={() => {
                      setActualizarCuentas(Math.random() * 40);
                    }}
                  ></ListadoTarjeta>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
